<template>
  <CodesHistoryPanel
    :include-doorphone-address="true"
    temp-route="ReportTempCodeProvisionHistory"
    service-route="ReportServiceDoorCodeHistory"
  />
</template>

<script>
import CodesHistoryPanel from '@/components/doorphone/DetailDoorphone/components/CodesHistoryPanel.vue';

export default {
  name: 'ReportsCodesHistoryTab',
  components: { CodesHistoryPanel },
};
</script>
